import { render, staticRenderFns } from "./allReviewSheet.vue?vue&type=template&id=0fa8c7ef&scoped=true&"
import script from "./allReviewSheet.vue?vue&type=script&lang=js&"
export * from "./allReviewSheet.vue?vue&type=script&lang=js&"
import style0 from "./allReviewSheet.vue?vue&type=style&index=0&id=0fa8c7ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8c7ef",
  null
  
)

export default component.exports